import React, { Component } from "react";
import _ from "lodash";
import {
  Image,
  Button,
  Checkbox,
  Segment,
  Form,
  Dropdown,
  Icon,
  Accordion,
  Menu,
  Sidebar,
  Card,
  Container,
  Label,
  Breadcrumb,
} from "semantic-ui-react";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import {
  storeAutoLoanDetails,
  getAutoLoanData,
  storeAutoLoanFilterValue,
  storeCategoryAutoLoanCount,
  compareAutoLoanData,
  storeSimulateEmail,
  storeAllAutoLoanDetails,
  appliedAutoLoanEmi,
  removedAutoLoanEmi,
  storeAutoLoanEmiInputValue,
  setGotAutoLoanDataFromApi,
  storeApplyFormInput,
  makeapplySuccess,
} from "../../redux/actions";
import Filter from "./Filter";
import SidePdp from "./SidePdp";
import { applyFilterCalculation } from "./applyFilter";
import { getConst } from "../../core/consts";
import CardCompare from "./CardCompare";
import DirectApply from "../applyForm/directapply";
import accounting from "accounting";
import BannerAutoLoan from "./BannerAutoLoan";
import $ from "jquery";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import { submitSimulate } from "../../core/apiClient";
import { getStaticText } from "../../core/lang";
import ApplyForm from "../applyForm/applyForm";
import Helmet from "react-helmet";
import { BrowserView, isIOS } from "react-device-detect";
import { source } from "../faq/datas";
import ReactGA from "react-ga";
import ReactPixel from "react-facebook-pixel";
import { autoLoanTag } from "./AutoLoanTag";
import GeneralForm from "../applyForm/generalForm";

export class AutoLoans extends Component {
  constructor() {
    super();
    this.state = {
      activeQuickViewIndex: "",
      toggleVisible: false,
      showMoreCardObj: {},
      compareCards: [],
      compareChecked: {},
      applyFlag: false,
      simulator: false,
      compareCardsPopup: false,
      cardObjectForSearch: [],
      applyCardObject: {},
      applyCards: [],
      applyCardChecked: {},
      directApply: false,
      downPaymentAscending: false,
      fixedRateAscending: false,
      emiAscending: false,
      reducingRateAscending: false,
      maxLoanAmountAscending: false,
      minimumSalaryAscending: false,
      numberOfCardToShow: 10,
      sidePdpEnableButton: {
        allowChange: true,
        previous: false,
        next: true,
      },
      salary: 5000,
      sortBy: "",
      searchQuery: "",
      carPrice: 0,
      downPayment: 0,
      downPaymentAmount: 0,
      term: 0,
      loanAmount: 0,
      propertyType: "First Property",
      nationality: "UAE",
      simulateEmail: "",
      simulateEmailError: "",
      disableEmiCalculateButton: false,
      pdpFor: "",
      phoneNumberCode: "050",
      goodTimeToCall: "",
      errors: {
        firstName: "",
        lastName: "",
        phoneNumber: "",
        emailId: "",
        terms: "",
        salary: "",
      },
      make_tip_visible: false,
      showContractAlert: false,
      autoLoan: [],
      expandAll: true,
      sortValue: "",
    };
    this.simulatorClose = this.simulatorClose.bind(this);
    this.compareCardsPopup = this.compareCardsPopup.bind(this);
    this.removeCompareCard = this.removeCompareCard.bind(this);
    this.applyCreditCard = this.applyCreditCard.bind(this);
    this.onCompareCardSearchChange = this.onCompareCardSearchChange.bind(this);
    this.closeDirectApplyPopup = this.closeDirectApplyPopup.bind(this);
    this.closeSidePdp = this.closeSidePdp.bind(this);
    this.closeApplyFormInCompare = this.closeApplyFormInCompare.bind(this);
    this.toggleVisibilityForPdp = this.toggleVisibilityForPdp.bind(this);
    this.changePdpByCardId = this.changePdpByCardId.bind(this);
    this.changeSidePdp = this.changeSidePdp.bind(this);
    this.compareSimulatePopup = this.compareSimulatePopup.bind(this);
    this.handleMultipleApplyCard = this.handleMultipleApplyCard.bind(this);
    this.simulatorClick = this.simulatorClick.bind(this);
    this.sortAfterFilter = this.sortAfterFilter.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
  }
  state = { activeIndex: 0 };

  handleClick = (e, titleProps) => {
    if (this.state.expandAll) {
      this.handleExpandCollapse();
    } else {
      const { index } = titleProps;
      const { activeIndex } = this.state;
      const newIndex = activeIndex === index ? -1 : index;
      this.setState({ activeIndex: newIndex, expandAll: false });
    }
  };

  handleApplyConfirm = () => {
    this.props.makeapplySuccess("", false);
  };

  relesebackground = () => {
    $("body").css("position", "relative");
    $("body").css("overflow-y", "auto");
  };
  lockbackground = () => {
    $("body").css("overflow", "hidden");
  };

  handleExpandCollapse = (e) => {
    if (this.state.expandAll) {
      $(".listFaq .ui.accordion > .title").removeClass("active");
      $(".listFaq .ui.accordion > .content").removeClass("active");
      this.setState({ expandAll: false, activeIndex: 0 });
    } else {
      $(".listFaq .ui.accordion > .title").addClass("active");
      $(".listFaq .ui.accordion > .content").addClass("active");
      this.setState({ expandAll: true });
    }
  };
  componentWillMount() {
    let sortValue = localStorage.getItem("sortValue");
    this.setState({ sortValue: sortValue });
    this.handleSorting(sortValue);

    $("html,body").animate(
      {
        scrollTop: 0,
      },
      300
    );
    window.onload = () => {
      $("html,body").animate(
        {
          scrollTop: 0,
        },
        200
      );
    };
    if (
      _.has(this.props.location, "query") &&
      _.has(this.props.location.query, "searchData") &&
      !_.isEmpty(this.props.location.query.searchData)
    ) {
      this.props.storeAllAutoLoanDetails(this.props.location.query.searchData);
      const {
        filteredCardArrayFinal,
        typeCountObj,
        autoLoanFeatureCountObj,
        carTypesCountObj,
        autoLoanBankCountObj,
      } = applyFilterCalculation(
        this.props.filterAttribute.selectedBanks,
        this.props.filterAttribute.selectedCardType,
        this.props.filterAttribute.selectedFeatures,
        this.props.filterAttribute.salary,
        this.props.filterAttribute.selectedCarType,
        this.props.location.query.searchData,
        this.props.filterAttribute.onlyContract
      );
      this.props.storeCategoryAutoLoanCount({
        typeCountObj,
        autoLoanFeatureCountObj,
        carTypesCountObj,
        autoLoanBankCountObj,
      });
      this.props.storeAutoLoanDetails(filteredCardArrayFinal);
      this.props.setGotAutoLoanDataFromApi(true);
      this.sortAfterFilter();
      this.setState({ searchQuery: this.props.location.query.searchQuery });
    } else {
      if (!this.props.gotAutoLoanDataFromApi) {
        this.props.getAutoLoanData();
        this.setState({ searchQuery: "" });
      }
    }
    this.setState({
      carPrice: this.props.autoLoanEmiInputValue.carPrice,
      downPayment: this.props.autoLoanEmiInputValue.downPayment,
      downPaymentAmount: this.props.autoLoanEmiInputValue.downPaymentAmount,
      term: this.props.autoLoanEmiInputValue.term,
      loanAmount: this.props.autoLoanEmiInputValue.loanAmount,
    });
    this.setState({ autoLoan: _.filter(source, { type: "autoLoan" }) });
  }

  handleMonthlySalaryChange = (value) => this.setState({ salary: value });

  componentWillReceiveProps(nextProps) {
    if (
      _.has(nextProps.location, "query") &&
      _.has(nextProps.location.query, "customOffer") &&
      nextProps.location.query.customOffer
    ) {
      this.simulatorClick();
    }
    if (
      _.has(nextProps.location, "query") &&
      _.has(nextProps.location.query, "simulateEmi") &&
      nextProps.location.query.simulateEmi &&
      !_.isEqual(this.props.location, nextProps.location)
    ) {
      $("html,body").animate(
        {
          scrollTop: 0,
        },
        300
      );
    }
    if (
      _.has(nextProps.location, "query") &&
      _.has(nextProps.location.query, "filter") &&
      !_.isEqual(this.props.location, nextProps.location)
    ) {
      const { loanAmount, fixedRate } = nextProps.location.query.filter;
      let filteredArray = [];
      if (loanAmount > 0 && fixedRate > 0) {
        filteredArray = _.filter(this.props.allCardDetails, (cardDetail) => {
          return (
            loanAmount <= cardDetail.maxLoanAmount &&
            fixedRate >= cardDetail.fixedRate
          );
        });
        const {
          filteredCardArrayFinal,
          typeCountObj,
          autoLoanFeatureCountObj,
          carTypesCountObj,
          autoLoanBankCountObj,
        } = applyFilterCalculation(
          this.props.filterAttribute.selectedBanks,
          this.props.filterAttribute.selectedCardType,
          this.props.filterAttribute.selectedFeatures,
          this.props.filterAttribute.salary,
          this.props.filterAttribute.selectedCarType,
          filteredArray,
          this.props.filterAttribute.onlyContract
        );
        this.props.storeCategoryAutoLoanCount({
          typeCountObj,
          autoLoanFeatureCountObj,
          carTypesCountObj,
          autoLoanBankCountObj,
        });
        this.props.storeAutoLoanDetails(filteredCardArrayFinal);
        this.sortAfterFilter();
      }
    }

    if (
      _.has(nextProps.location, "query") &&
      _.has(nextProps.location.query, "searchData") &&
      !_.isEmpty(nextProps.location.query.searchData) &&
      !_.isEqual(this.props.location, nextProps.location)
    ) {
      this.props.storeAllAutoLoanDetails(nextProps.location.query.searchData);
      const {
        filteredCardArrayFinal,
        typeCountObj,
        autoLoanFeatureCountObj,
        carTypesCountObj,
        autoLoanBankCountObj,
      } = applyFilterCalculation(
        this.props.filterAttribute.selectedBanks,
        this.props.filterAttribute.selectedCardType,
        this.props.filterAttribute.selectedFeatures,
        this.props.filterAttribute.salary,
        this.props.filterAttribute.selectedCarType,
        nextProps.location.query.searchData,
        this.props.filterAttribute.onlyContract
      );
      this.props.storeCategoryAutoLoanCount({
        typeCountObj,
        autoLoanFeatureCountObj,
        carTypesCountObj,
        autoLoanBankCountObj,
      });
      this.props.storeAutoLoanDetails(filteredCardArrayFinal);
      this.sortAfterFilter();
      this.setState({ searchQuery: nextProps.location.query.searchQuery });
    }
  }

  handleInputChange = (e, { value, name }) => {
    const { telephone } = getConst(this.props.activeLanguage);
    if (name === "emailId") {
      value = value.trim();
    }
    if (name === "firstName" || name === "lastName") {
      value = value.toUpperCase();
    }
    if (name === "phoneNumber") {
      if (telephone.test(value)) {
        this.setState({
          [name]: value,
        });
      }
    } else {
      this.setState({
        [name]: value,
      });
    }
  };

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
    if (!_.isEmpty(this.state.searchQuery)) {
      this.props.storeAutoLoanDetails([]);
      this.props.storeAllAutoLoanDetails([]);
      this.props.setGotAutoLoanDataFromApi(false);
    }
  }

  handleScroll() {
    if ($(window).width() > 900) {
      let documentHeight = $(document).height();
      let scrollHeight = $(window).scrollTop() + $(window).height();
      if (
        documentHeight === scrollHeight &&
        this.state.numberOfCardToShow < this.props.cardDetails.length
      ) {
        this.setNumberOfCardToShow();
      }
    } else {
      const body = document.body;
      function getDocHeight() {
        var D = document;
        return Math.max(
          D.body.scrollHeight,
          D.documentElement.scrollHeight,
          D.body.offsetHeight,
          D.documentElement.offsetHeight,
          D.body.clientHeight,
          D.documentElement.clientHeight
        );
      }
      let docHeight = getDocHeight();
      const windowBottom = window.innerHeight + body.scrollTop;
      if (window.innerWidth <= 500) {
        docHeight = docHeight - 1000;
      }
      if (!isIOS) {
        if (
          windowBottom >= docHeight &&
          this.state.numberOfCardToShow < this.props.cardDetails.length
        ) {
          this.setNumberOfCardToShow();
        }
      }
    }
  }

  onFocusField = (name) => {
    this.setState({ onFocus: name });
  };

  componentDidMount() {
    //20/11 ReactPixel.fbq('init', '859843894357327');
    //20/11 ReactPixel.fbq('track', 'PageView');
    ReactPixel.fbq("init", "540765660010317");
    ReactPixel.fbq("track", "PageView");

    this.handleExpandCollapse();

    if (
      this.state.carPrice > 0 &&
      this.state.downPayment > 0 &&
      this.state.loanAmount > 0
    ) {
      this.setState({
        simulateEmail: this.props.simulateEmail,
        disableEmiCalculateButton: true,
      });
    } else {
      this.setState({
        simulateEmail: this.props.simulateEmail,
        disableEmiCalculateButton: false,
      });
    }

    window.addEventListener("scroll", () => {
      this.handleScroll();
      this.MobilecheckSticky();
    });
    window.addEventListener("touchmove", this.handleScroll);
    $("body").bind("scroll touchmove", () => {
      this.MobilecheckSticky();
      this.handleScroll();
    });
    let scroll;
    // if($(window).width()<768) {
    if ($(window).width() > 900) {
      $(window).on("scroll", function () {
        scroll = $(window).scrollTop();
        if (scroll >= 455) {
          $(".card-details .table").addClass("table-fixed");
          $(".card-details .table-fixed .table-head").css("top", "69px");
          $(".main-header").addClass("header-scroll");
        } else {
          $(".main-header").removeClass("header-scroll");
          $(".card-details .table").removeClass("table-fixed");
        }

        if (scroll >= 210) {
          $(".js-filter-box").addClass("sticky");
          $(".main-header").addClass("header-scroll");
          $(".sw-content-left").attr("style", "margin-top: 50px !important;");
        } else {
          $(".sw-content-left").css("marginTop", "0");
          $(".main-header").removeClass("header-scroll");
          $(".js-filter-box").removeClass("sticky");
        }
      });
    }
    window.addEventListener("keydown", function (e) {
      if (e.keyCode === 27 && $(".sidebar-more-details").hasClass("visible")) {
        $(".sidebar-more-details .sidebar-close").trigger("click");
      }
    });
    $(document).on("click", ".backdrop-sidebar", function () {
      $(".sidebar-container").animate(
        {
          scrollTop: 0,
        },
        0
      );
      $(".js-goto-feedback").removeClass("active");
      $(".sidebar-more-details .sidebar-close").trigger("click");
    });

    // if($(window).width()<768) {
    if ($(window).width() < 900) {
      $("footer").show();
      $(
        ".js-filter-box .panel-title.filter-auto-loan, .filter-cta-apply button"
      ).on("click", function () {
        $(".simulator-loans").hide();
        if ($(".sw-content-left").is(":visible")) {
          $(".sw-content-left").removeClass("open");
          $(".filter-cta-apply").removeClass("active");
        } else {
          $(".sw-content-left").addClass("open");
          $(".filter-cta-apply").addClass("active");
        }
        $(".sw-panel-right, footer").toggle();
        // $('.simulator-loans').hide();
        // $('.filter-cta-apply').toggleClass('active');
        $("html,body").animate(
          {
            scrollTop: 110,
          },
          300
        );
      });
      $(".js-auto-loan-simulate").on("click", function () {
        $(".sw-content-left").removeClass("open");
        $(".filter-cta-apply").removeClass("active");
        if ($(".simulator-loans").is(":visible")) {
          $(".simulator-loans").slideUp().removeClass("open");
        } else {
          $(".simulator-loans").slideDown().addClass("open");
        }
        $("html,body").animate(
          {
            scrollTop: 110,
          },
          300
        );
      });
    }
  }

  MobilecheckSticky() {
    let scroll = $("body").scrollTop();
    if (scroll >= 110) {
      $(".main-header").addClass("header-scroll");
      $(".loan-mobile-sticky").addClass("sticky");
      $(".sw-panel-wrap").css("marginTop", "35px");
      $(".sw-panel-right").css("marginTop", 0);
      $(".sw-panel-left .sw-content-left").attr(
        "style",
        "margin-top: 5px !important;"
      );
    } else {
      $(".main-header").removeClass("header-scroll");
      $(".sw-panel-wrap").css("marginTop", 0);
      $(".loan-mobile-sticky").removeClass("sticky");
      $(".sw-panel-left .sw-content-left").css("marginTop", 0);
    }
  }

  handleQuickViewClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeQuickViewIndex } = this.state;
    const newIndex = activeQuickViewIndex === index ? -1 : index;
    const cardname = this.props.cardDetails[index].name;
    this.setState({ activeQuickViewIndex: newIndex });

    ReactGA.event({
      category: "Auto Loan",
      action: cardname + "-QuickView",
    });
  };

  changeSidePdp = (e, titleProps) => {
    const { card, changeby } = titleProps;
    if (this.state.pdpFor === "compare") {
      const index = _.add(_.findIndex(this.props.compareCards, card), changeby);
      this.setButtonVisibilityForComparePdp(index);
      $(".sidebar-container").animate(
        {
          scrollTop: 0,
        },
        0
      );
      this.setState({
        showMoreCardObj: this.props.compareCards[index],
      });
    } else {
      const { activeQuickViewIndex } = this.state;
      const index = _.add(_.findIndex(this.props.cardDetails, card), changeby);
      this.setButtonVisibility(index);
      const newIndex = activeQuickViewIndex === index ? -1 : index;
      $(".sidebar-container").animate(
        {
          scrollTop: 0,
        },
        0
      );
      this.setState({
        activeQuickViewIndex: newIndex,
        showMoreCardObj: this.props.cardDetails[index],
      });
    }
  };

  setButtonVisibility = (index) => {
    let previous = true,
      next = true;
    if (index < 1) {
      previous = false;
    }
    if (index > this.props.cardDetails.length - 2) {
      next = false;
    }
    this.setState({
      sidePdpEnableButton: {
        allowChange: true,
        previous,
        next,
      },
    });
  };

  toggleVisibilityForRivews = (e, titleProps) => {
    const { tabIndex } = titleProps;

    setTimeout(() => {
      var st = $(".sidebar-container #feedback-comments").offset().top;
      $(".sidebar-container").animate(
        {
          scrollTop: st - 160,
        },
        800
      );
      $(".js-goto-feedback").addClass("active");
    }, 200);

    const showMoreCardObj = _.find(this.props.allCardDetails, ["id", tabIndex]);
    const index = _.findIndex(this.props.cardDetails, showMoreCardObj);
    this.setButtonVisibility(index);
    this.setState({ showMoreCardObj, pdpFor: "" }, () => {
      this.setState({
        toggleVisible: !this.state.toggleVisible,
      });
    });
  };

  toggleVisibilityForDetails = (e, titleProps) => {
    const { tabIndex } = titleProps;
    $(".sidebar-container").animate(
      {
        scrollTop: 0,
      },
      0
    );
    $(".js-goto-feedback").removeClass("active");
    const showMoreCardObj = _.find(this.props.allCardDetails, ["id", tabIndex]);
    const index = _.findIndex(this.props.cardDetails, showMoreCardObj);
    this.setButtonVisibility(index);
    this.setState({ showMoreCardObj, pdpFor: "" }, () => {
      this.setState({
        toggleVisible: !this.state.toggleVisible,
      });
    });
    const cardname = showMoreCardObj.name;
    const bankname = showMoreCardObj.bankName;

    ReactGA.event({
      category: "Auto Loan",
      action: bankname + cardname + "-Quickview-Moredetails",
    });
    this.lockbackground();
  };

  toggleVisibilityForPdp = (e, titleProps) => {
    const { tabIndex } = titleProps;
    $(".sidebar-container").animate(
      {
        scrollTop: 0,
      },
      0
    );
    $(".js-goto-feedback").removeClass("active");
    const showMoreCardObj = _.find(this.props.allCardDetails, ["id", tabIndex]);
    const index = _.findIndex(this.props.compareCards, showMoreCardObj);
    this.setButtonVisibilityForComparePdp(index);
    this.setState({ showMoreCardObj, pdpFor: "compare" }, () => {
      this.setState({
        toggleVisible: !this.state.toggleVisible,
      });
    });
  };

  setButtonVisibilityForComparePdp = (index) => {
    let previous = true,
      next = true;
    if (index < 1) {
      previous = false;
    }
    if (index > this.props.compareCards.length - 2) {
      next = false;
    }
    this.setState({
      sidePdpEnableButton: {
        allowChange: true,
        previous,
        next,
      },
    });
  };

  changePdpByCardId = (id) => {
    const {
      filteredCardArrayFinal,
      typeCountObj,
      autoLoanFeatureCountObj,
      carTypesCountObj,
      autoLoanBankCountObj,
    } = applyFilterCalculation(
      this.props.filterAttribute.selectedBanks,
      this.props.filterAttribute.selectedCardType,
      this.props.filterAttribute.selectedFeatures,
      this.props.filterAttribute.salary,
      this.props.filterAttribute.selectedCarType,
      this.props.allCardDetails,
      this.props.filterAttribute.onlyContract
    );
    this.props.storeCategoryAutoLoanCount({
      typeCountObj,
      autoLoanFeatureCountObj,
      carTypesCountObj,
      autoLoanBankCountObj,
    });
    this.props.storeAutoLoanDetails(filteredCardArrayFinal);
    this.setState({
      showMoreCardObj: _.find(this.props.allCardDetails, ["id", id]),
    });
    this.sortAfterFilter();
  };

  closeSidePdp = () => {
    this.setState({ toggleVisible: false });
    $(".sidebar-container").animate(
      {
        scrollTop: 0,
      },
      0
    );
    this.relesebackground();
  };

  handleContractAlert = () => {
    if ($(window).width() < 768) {
      this.setState({
        showContractAlert: !this.state.showContractAlert,
      });
    }
  };

  simulatorClose = () => this.setState({ simulator: false });

  simulatorClick = () => this.setState({ simulator: true });

  compareCardsPopup = () => {
    this.setState(
      {
        compareCardsPopup: !this.state.compareCardsPopup,
        applyFlag: false,
      },
      () => this.makeSearchObjectforCompare()
    );
  };

  makeSearchObjectforCompare = () => {
    let cardObjectForSearch = [];
    const remainingCardForCompare = _.differenceBy(
      this.props.allCardDetails,
      this.props.compareCards,
      "id"
    );
    _.forEach(remainingCardForCompare, (item) => {
      cardObjectForSearch.push({
        key: item.id,
        value: item.id,
        text: item.bankName + " - " + item.name,
      });
    });
    this.setState({
      cardObjectForSearch,
    });
  };

  handleCompareCard = (e, { value, checked }) => {
    const cardDetail = _.find(this.props.allCardDetails, ["id", value]);
    let compareCards = [];
    if (checked) {
      compareCards = _.concat(this.props.compareCards, cardDetail);
    } else {
      compareCards = _.remove(this.props.compareCards, (n) => {
        return n.id !== value;
      });
    }
    if (_.isEmpty(compareCards)) {
      $(".sw-panel").css("marginTop", "14px");
      $(".main-header").removeClass("header-scroll");
      $(".card-details .table-fixed .table-head").css("top", "69px");
      $(".js-filter-box").css("marginTop", 0);
    }
    if (!($(window).width() > 768)) {
      if (compareCards.length < 3) {
        const compareChecked = _.assign(this.props.compareChecked, {
          [value]: checked,
        });
        this.setState({
          compareCards,
          compareChecked,
        });
        this.props.compareAutoLoanData({
          compareCards,
          compareChecked,
        });
      }
    } else {
      if (compareCards.length < 5) {
        const compareChecked = _.assign(this.props.compareChecked, {
          [value]: checked,
        });
        this.setState({
          compareCards,
          compareChecked,
        });
        this.props.compareAutoLoanData({
          compareCards,
          compareChecked,
        });
      }
    }
    const cardname = _.find(this.props.allCardDetails, ["id", value]).name;
    ReactGA.event({
      category: "Auto Loan",
      action: cardname + "-Compare",
    });
  };

  handleMultipleApplyCard = (e, { value, checked }) => {
    const cardDetail = _.find(this.props.allCardDetails, ["id", value]);
    let applyCards = [];
    if (checked) {
      applyCards = _.uniqBy(_.concat(this.state.applyCards, cardDetail), "id");
    } else {
      applyCards = _.remove(this.state.applyCards, (n) => {
        return n.id !== value;
      });
    }
    const applyCardChecked = _.assign(this.state.applyCardChecked, {
      [value]: checked,
    });
    this.setState({
      applyCards,
      applyCardChecked,
    });
  };

  onCompareCardSearchChange = (e, { preid, value }) => {
    let compareChecked = _.assign(this.props.compareChecked, {
      [preid]: false,
    });
    const cardDetail = _.find(this.props.allCardDetails, ["id", value]);
    let compareCards = this.props.compareCards;
    if (preid) {
      _.forEach(this.props.compareCards, (item) => {
        if (item.id === preid) {
          let currentIndex = _.indexOf(this.props.compareCards, item, 0);
          compareCards[currentIndex] = cardDetail;
        }
      });
    } else {
      compareCards = _.concat(this.props.compareCards, cardDetail);
    }
    compareChecked = _.assign(this.props.compareChecked, { [value]: true });
    this.props.compareAutoLoanData({
      compareCards,
      compareChecked,
    });
    this.setState(
      {
        compareCards,
        compareChecked,
      },
      () => this.makeSearchObjectforCompare()
    );
  };

  removeCompareCard = (e, { value }) => {
    const compareChecked = _.assign(this.props.compareChecked, {
      [value]: false,
    });
    let compareCards = _.remove(this.props.compareCards, (n) => {
      return n.id !== value;
    });
    if (_.isEmpty(compareCards)) {
      $(".sw-panel").css("marginTop", "14px");
      $(".main-header").removeClass("header-scroll");
      $(".card-details .table-fixed .table-head").css("top", "69px");
      $(".js-filter-box").css("marginTop", 0);
      this.setState({
        applyFlag: false,
        applyCards: [],
        applyCardChecked: {},
      });
    }
    this.props.compareAutoLoanData({
      compareCards,
      compareChecked,
    });
    this.setState(
      {
        compareCards,
        compareChecked,
        applyFlag: false,
        applyCards: [],
        applyCardChecked: {},
      },
      () => this.makeSearchObjectforCompare()
    );
  };

  applyCreditCard = (e, { value }) =>
    this.setState({
      applyFlag: true,
      applyCardObjectForComparePage: _.find(this.props.allCardDetails, [
        "id",
        value,
      ]),
    });

  // applyCreditCard = (e, {value}) => {
  //     if (!_.isEmpty(this.state.applyCards)) {
  //       this.setState({
  //         applyFlag: true
  //       });
  //     }
  // }

  closeApplyFormInCompare = () =>
    this.setState({
      applyFlag: false,
      applyCards: [],
      applyCardChecked: {},
    });

  applyDirect = (e, { cardid }) => {
    this.setState({
      applyCardObject: _.find(this.props.allCardDetails, ["id", cardid]),
      directApply: true,
    });
  };

  applyDirectFromsidePDP = (e, cardid) => {
    this.setState({
      applyCardObject: _.find(this.props.allCardDetails, ["id", cardid]),
      directApply: true,
    });
  };

  closeDirectApplyPopup = () => this.setState({ directApply: false });

  changeFilterAttribute = (e, { value, name }) => {
    let selectedBanks = this.props.filterAttribute.selectedBanks;
    let selectedCardType = this.props.filterAttribute.selectedCardType;
    let selectedFeatures = this.props.filterAttribute.selectedFeatures;
    let selectedCarType = this.props.filterAttribute.selectedCarType;
    let onlyContract = this.props.filterAttribute.onlyContract;
    switch (name) {
      case "bank":
        selectedBanks = _.remove(
          this.props.filterAttribute.selectedBanks,
          (n) => {
            return n !== value;
          }
        );
        break;
      case "carType":
        selectedCarType = "";
        break;
      case "type":
        selectedCardType = "";
        break;
      case "feature":
        selectedFeatures = _.remove(
          this.props.filterAttribute.selectedFeatures,
          (n) => {
            return n !== value;
          }
        );
        break;
      case "contract":
        onlyContract = false;
        break;
      default:
    }
    const {
      filteredCardArrayFinal,
      typeCountObj,
      autoLoanFeatureCountObj,
      carTypesCountObj,
      autoLoanBankCountObj,
    } = applyFilterCalculation(
      selectedBanks,
      selectedCardType,
      selectedFeatures,
      this.props.filterAttribute.salary,
      selectedCarType,
      this.props.allCardDetails,
      false
    );
    this.props.storeCategoryAutoLoanCount({
      typeCountObj,
      autoLoanFeatureCountObj,
      carTypesCountObj,
      autoLoanBankCountObj,
    });
    this.props.storeAutoLoanDetails(filteredCardArrayFinal);
    this.props.storeAutoLoanFilterValue({
      selectedBanks,
      selectedCardType,
      selectedFeatures,
      salary: this.props.filterAttribute.salary,
      selectedCarType,
      onlyContract,
    });
    this.sortAfterFilter();
  };

  clearAllFilter = () => {
    const {
      filteredCardArrayFinal,
      typeCountObj,
      autoLoanFeatureCountObj,
      carTypesCountObj,
      autoLoanBankCountObj,
    } = applyFilterCalculation(
      [],
      "",
      [],
      50000,
      "",
      this.props.allCardDetails,
      false
    );
    this.props.storeCategoryAutoLoanCount({
      typeCountObj,
      autoLoanFeatureCountObj,
      carTypesCountObj,
      autoLoanBankCountObj,
    });
    this.props.storeAutoLoanDetails(filteredCardArrayFinal);
    this.props.storeAutoLoanFilterValue({
      selectedBanks: [],
      selectedCardType: "",
      selectedFeatures: [],
      salary: 50000,
      selectedCarType: "",
    });
    this.props.storeAutoLoanDetails(this.props.allCardDetails);
    this.sortAfterFilter();
  };

  clearSearchResult = () => {
    this.setState({
      searchQuery: "",
    });
    this.props.getAutoLoanData();
    this.clearAllFilter();
  };

  downPaymentSort = () => {
    let sortByMinimumSalary = [];
    if (this.state.downPaymentAscending) {
      sortByMinimumSalary = _.sortBy(this.props.cardDetails, [
        "downPayment",
        "name",
      ]);
    } else {
      sortByMinimumSalary = _.reverse(
        _.sortBy(this.props.cardDetails, ["downPayment"])
      );
    }
    this.setState({
      downPaymentAscending: !this.state.downPaymentAscending,
      activeQuickViewIndex: "",
      sortBy: "downPayment",
    });
    this.props.storeAutoLoanDetails(sortByMinimumSalary);
  };

  fixedRateSort = () => {
    let sortByAnnualFee = [];
    if (this.state.fixedRateAscending) {
      sortByAnnualFee = _.sortBy(this.props.cardDetails, ["fixedRate", "name"]);
    } else {
      sortByAnnualFee = _.reverse(
        _.sortBy(this.props.cardDetails, ["fixedRate"])
      );
    }
    this.setState({
      fixedRateAscending: !this.state.fixedRateAscending,
      activeQuickViewIndex: "",
      sortBy: "fixedRate",
    });
    this.props.storeAutoLoanDetails(sortByAnnualFee);
  };

  reducingRateSort = () => {
    let sortByRate = [];
    if (this.state.reducingRateAscending) {
      sortByRate = _.sortBy(this.props.cardDetails, ["reducingRate", "name"]);
    } else {
      sortByRate = _.reverse(
        _.sortBy(this.props.cardDetails, ["reducingRate"])
      );
    }
    this.setState({
      reducingRateAscending: !this.state.reducingRateAscending,
      activeQuickViewIndex: "",
      sortBy: "reducingRate",
    });
    this.props.storeAutoLoanDetails(sortByRate);
  };

  emiSort = () => {
    let sortByEmi = [];
    if (this.state.emiAscending) {
      sortByEmi = _.sortBy(this.props.cardDetails, ["emi", "name"]);
    } else {
      sortByEmi = _.reverse(_.sortBy(this.props.cardDetails, ["emi"]));
    }
    this.setState({
      emiAscending: !this.state.emiAscending,
      activeQuickViewIndex: "",
      sortBy: "emi",
    });
    this.props.storeAutoLoanDetails(sortByEmi);
  };

  maxLoanAmountSort = () => {
    let sortByMaxAutoLoanAmount = [];
    if (this.state.maxLoanAmountAscending) {
      sortByMaxAutoLoanAmount = _.sortBy(this.props.cardDetails, [
        "maxLoanAmount",
        "name",
      ]);
    } else {
      sortByMaxAutoLoanAmount = _.reverse(
        _.sortBy(this.props.cardDetails, ["maxLoanAmount"])
      );
    }
    this.setState({
      maxLoanAmountAscending: !this.state.maxLoanAmountAscending,
      activeQuickViewIndex: "",
      sortBy: "maxLoanAmount",
    });
    this.props.storeAutoLoanDetails(sortByMaxAutoLoanAmount);
  };
  minimumSalarySort = () => {
    let sortByMinimumSalary = [];
    if (this.state.minimumSalaryAscending) {
      sortByMinimumSalary = _.sortBy(this.props.cardDetails, [
        "minimumSalary",
        "name",
      ]);
    } else {
      sortByMinimumSalary = _.reverse(
        _.sortBy(this.props.cardDetails, ["minimumSalary"])
      );
    }
    this.setState({
      minimumSalaryAscending: !this.state.minimumSalaryAscending,
      activeQuickViewIndex: "",
      sortBy: "minimumSalary",
    });
    this.props.storeAutoLoanDetails(sortByMinimumSalary);
  };

  setNumberOfCardToShow = () =>
    this.setState({ numberOfCardToShow: this.state.numberOfCardToShow + 10 });

  resetCompareCard = () => {
    $(".sw-panel").css("marginTop", "14px");
    $(".card-details .table-fixed .table-head").css("top", "69px");
    $(".js-filter-box").css("marginTop", 0);
    $(".main-header").removeClass("header-scroll");
    this.props.compareAutoLoanData({
      compareCards: [],
      compareChecked: {},
    });
    this.setState({ compareCards: [], compareChecked: {} });
  };

  compareSimulatePopup = () => {
    this.compareCardsPopup();
    this.simulatorClick();
  };

  onCarPriceChange = (value) => {
    this.setState({ carPrice: value }, () => {
      this.setCalculateValue();
    });
  };
  onDownPaymentChange = (value) => {
    this.setState({ downPayment: value.toFixed(2) }, () => {
      this.setCalculateValue();
    });
  };

  setCalculateValue = () => {
    let loanAmount = 0;
    let downPaymentAmount = 0;
    if (this.state.carPrice > 0 && this.state.downPayment > 0) {
      downPaymentAmount = _.round(
        _.divide(
          _.multiply(
            _.toNumber(this.state.carPrice),
            _.toNumber(this.state.downPayment)
          ),
          100
        ),
        0
      );
      loanAmount = _.toNumber(this.state.carPrice) - downPaymentAmount;
    }
    this.setState({ downPaymentAmount, loanAmount }, () => {
      if (this.state.disableEmiCalculateButton) {
        this.emiCalculation();
      }
    });
  };

  onTermChange = (value) => {
    this.setState({ term: value }, () => {
      if (this.state.disableEmiCalculateButton) {
        this.emiCalculation();
      }
    });
  };

  handleCarInputChange = (e, { value, name, max }) => {
    let validValue = value;
    if (name === "carPrice") {
      validValue = accounting.unformat(value);
    }
    if (max < validValue) {
      validValue = max;
    }
    this.setState(
      {
        [name]: _.toNumber(validValue),
      },
      () => this.setCalculateValue()
    );
  };

  handleSimulateEmailChange = (e, { value }) => {
    this.setState({ simulateEmail: value });
  };

  editSimulateEmail = () => {
    this.setState({
      simulateEmail: this.props.simulateEmail,
      disableEmiCalculateButton: false,
    });
    this.props.storeSimulateEmail(this.props.simulateEmail, true);
  };

  calculateEmi = () => {
    if (
      this.validateEmail() &&
      this.state.term > 0 &&
      this.state.carPrice > 0 &&
      this.state.downPayment > 0
    ) {
      let email = this.state.simulateEmail;
      if (_.isEmpty(email)) {
        email = this.props.simulateEmail;
      }
      this.props.storeSimulateEmail(email, false);
      this.setState({ disableEmiCalculateButton: true });
      this.emiCalculation();
    }
    ReactGA.event({
      category: "Auto Loan",
      action: "Savings Simulator",
    });
  };

  emiCalculation = () => {
    if (
      this.validateEmail() &&
      this.state.term > 0 &&
      this.state.carPrice > 0 &&
      this.state.downPayment > 0
    ) {
      const allCardDetails = this.props.allCardDetails;
      const emiCardDetails = [];
      const downPaymentAmount = this.state.downPaymentAmount;
      const autoLoanAmount =
        _.toNumber(this.state.carPrice) - downPaymentAmount;
      const tenure = _.toNumber(this.state.term);

      _.forEach(allCardDetails, (card) => {
        let loanAmount;
        if (card.maxLoanAmount >= autoLoanAmount) {
          //loanAmount = _.toNumber(card.maxLoanAmount);
          //else
          loanAmount = _.toNumber(autoLoanAmount);
          const intr = _.round(_.toNumber(_.divide(card.fixedRate, 1200)), 5);
          const top = _.round(
            _.round(loanAmount * intr, 5) * Math.pow(1 + intr, tenure),
            5
          );
          const bottom = _.round(Math.pow(1 + intr, tenure) - 1, 5);
          const emi = _.round(_.divide(top, bottom), 2);
          card.emi = emi;
          card.autoLoanAmount = loanAmount;
          emiCardDetails.push(card);
        }
      });
      //this.props.storeAllAutoLoanDetails(emiCardDetails);
      const {
        filteredCardArrayFinal,
        typeCountObj,
        autoLoanFeatureCountObj,
        carTypesCountObj,
        autoLoanBankCountObj,
      } = applyFilterCalculation(
        this.props.filterAttribute.selectedBanks,
        this.props.filterAttribute.selectedCardType,
        this.props.filterAttribute.selectedFeatures,
        this.props.filterAttribute.salary,
        this.props.filterAttribute.selectedCarType,
        emiCardDetails,
        false,
        autoLoanAmount
      );
      this.props.storeCategoryAutoLoanCount({
        typeCountObj,
        autoLoanFeatureCountObj,
        carTypesCountObj,
        autoLoanBankCountObj,
      });
      this.props.storeAutoLoanDetails(
        _.reverse(_.sortBy(filteredCardArrayFinal, ["emi", "maxLoanAmount"]))
      );
      this.setState({
        sortBy: "emi",
        activeQuickViewIndex: "",
        emiAscending: false,
      });
      this.props.appliedAutoLoanEmi();
      this.trackEmiCalculation();
      this.sortAfterFilter();
      this.props.storeAutoLoanEmiInputValue({
        carPrice: this.state.carPrice,
        downPayment: this.state.downPayment,
        downPaymentAmount: this.state.downPaymentAmount,
        term: this.state.term,
        loanAmount: this.state.loanAmount,
      });
    }
  };

  trackEmiCalculation = () => {
    let email = this.state.simulateEmail;
    if (_.isEmpty(email)) {
      email = this.props.simulateEmail;
    }
    submitSimulate({
      simulation: {
        email,
        carPrice: this.state.carPrice,
        terms: this.state.term,
        downPayment: this.state.downPayment,
        loanAmount: this.state.loanAmount,
      },
    }).then((response) => {
      this.props.storeApplyFormInput({
        emailId: email,
      });
    });
  };

  validateEmail = () => {
    const { please_enter_valid_email } = getStaticText(
      this.props.activeLanguage
    );
    const { emailRegex } = getConst(this.props.activeLanguage);
    if (!emailRegex.test(this.state.simulateEmail)) {
      this.setState({ simulateEmailError: please_enter_valid_email });
      return false;
    }
    let email = this.state.simulateEmail;
    if (_.isEmpty(email)) {
      email = this.props.simulateEmail;
    }
    this.setState({ simulateEmailError: "", simulateEmail: email });
    return true;
  };

  digitValidate = (e) => {
    const re = /^[0-9.]*$/;
    if (!re.test(e.key)) {
      e.preventDefault();
    }
  };

  sortAfterFilter = () => {
    if (_.isFunction(this[`${this.state.sortBy}Sort`])) {
      setTimeout(() => {
        this.setState(
          {
            [`${this.state.sortBy}Ascending`]:
              !this.state[`${this.state.sortBy}Ascending`],
          },
          () => this[`${this.state.sortBy}Sort`].call()
        );
      }, 1000);
    }
    $("html,body").animate(
      {
        scrollTop: 0,
      },
      300
    );
  };

  handleTimeToCall = (e, { value }) => {
    this.setState({ goodTimeToCall: value });
  };

  submitted = () => {
    this.props.history.push("/credit-cards");
    this.hideQuickView();
    this.closeAllApplyPopup();
  };

  suggest = (salary) => {
    this.props.history.push("/car-loans");
    this.hideQuickView();
    this.applyFilter(salary);
  };

  applyFilter = (salary) => {
    if (salary > 50000) {
      salary = 50000;
    }
    let selectedBanks = this.props.filterAttribute.selectedBanks;
    let selectedCardType = this.props.filterAttribute.selectedCardType;
    let selectedFeatures = this.props.filterAttribute.selectedFeatures;
    let selectedCarType = this.props.filterAttribute.selectedCarType;
    let onlyContract = true;
    var {
      filteredCardArrayFinal,
      typeCountObj,
      autoLoanFeatureCountObj,
      carTypesCountObj,
      autoLoanBankCountObj,
    } = applyFilterCalculation(
      selectedBanks,
      selectedCardType,
      selectedFeatures,
      salary,
      selectedCarType,
      this.props.allCardDetails,
      onlyContract
    );
    if (
      filteredCardArrayFinal.length === 0 &&
      this.props.filterAttribute.selectedBanks.length > 0
    ) {
      selectedBanks = [];
      var {
        filteredCardArrayFinal,
        typeCountObj,
        autoLoanFeatureCountObj,
        carTypesCountObj,
        autoLoanBankCountObj,
      } = applyFilterCalculation(
        selectedBanks,
        selectedCardType,
        selectedFeatures,
        salary,
        selectedCarType,
        this.props.allCardDetails,
        onlyContract
      );
    }
    this.props.storeCategoryAutoLoanCount({
      typeCountObj,
      autoLoanFeatureCountObj,
      carTypesCountObj,
      autoLoanBankCountObj,
    });
    this.props.storeAutoLoanDetails(filteredCardArrayFinal);
    this.props.storeAutoLoanFilterValue({
      selectedBanks,
      selectedCardType,
      selectedFeatures,
      salary: salary,
      selectedCarType,
      onlyContract,
    });
    this.sortAfterFilter();
  };

  hideQuickView = () => {
    this.setState({ activeQuickViewIndex: -1 });
  };

  handleTerms = (e, { checked }) => {
    this.setState({ terms: checked });
  };

  handleTermsValidate = () => {
    let valid = false;
    const { accept_terms_message } = getStaticText(this.props.activeLanguage);
    if (!this.state.terms) {
      this.createError("terms", accept_terms_message);
    } else {
      this.createError("terms", "");
      valid = true;
    }
    return valid;
  };

  handleEmailIdBlur = () => {
    let email = this.state.emailId;
    let valid = false;
    const { email_id_required_msg, email_id_valid_msg } = getStaticText(
      this.props.activeLanguage
    );
    const { emailRegex } = getConst(this.props.activeLanguage);
    if (_.isEmpty(email)) {
      this.createError("emailId", email_id_required_msg);
    } else if (!emailRegex.test(email)) {
      this.createError("emailId", email_id_valid_msg);
    } else {
      this.createError("emailId", "");
      valid = true;
    }
    this.onFocusField("");
    return valid;
  };

  createError = (field, error) => {
    const errors = _.assign(this.state.errors, { [field]: error });
    this.setState({
      errors,
    });
  };

  //   handleInputChange = (e, {value, name}) => {
  //     const {telephone} = getConst(this.props.activeLanguage);
  //     if(name === 'emailId'){
  //       value = value.trim();
  //     }
  //     if (name === 'phoneNumber') {
  //       if (telephone.test(value)) {
  //         this.setState({
  //           [name]: value
  //         })
  //       }
  //     } else {
  //       this.setState({
  //         [name]: value
  //       })
  //     }
  //   }

  digitValidate = (e) => {
    const re = /^[0-9.]*$/;
    if (!re.test(e.key)) {
      e.preventDefault();
    }
  };

  closeAllApplyPopup = () => {
    const { applying_auto_loan_with_us } = getStaticText(
      this.props.activeLanguage
    );
    const bankname =
      this.props.cardDetails[this.state.activeQuickViewIndex].bankName;
    const cardname =
      this.props.cardDetails[this.state.activeQuickViewIndex].name;
    const id = this.props.cardDetails[this.state.activeQuickViewIndex].id;
    this.props.makeapplySuccess(
      `${applying_auto_loan_with_us} <strong> ${bankname} - ${cardname}</strong>`,
      true
    );
    this.setState({ activeQuickViewIndex: -1 });
    //this.props.history.push("/credit-cards");
    this.props.history.push(`/thank-you-page/${cardname}/${id}`);
    this.setState({
      terms: false,
      goodTimeToCall: "",
      errors: {
        firstName: "",
        lastName: "",
        phoneNumber: "",
        emailId: "",
        terms: "",
        salary: "",
      },
    });
  };

  onChangeSort = (e, { value }) =>
    this.setState({ sortValue: value }, () =>
      this.handleSorting(this.state.sortValue)
    );

  handleSorting = (value) => {
    switch (value) {
      case "minimumSalaryAsc":
        this.setState({ minimumSalaryAscending: true }, () => {
          this.minimumSalarySort();
        });

        break;
      case "minimumSalaryDesc":
        this.setState({ minimumSalaryAscending: false }, () => {
          this.minimumSalarySort();
        });
        break;
      case "FixedRateAsc":
        this.setState({ fixedRateAscending: true }, () => {
          this.fixedRateSort();
        });
        break;
      case "FixedRateDesc":
        this.setState({ fixedRateAscending: false }, () => {
          this.fixedRateSort();
        });
        break;
      case "ReducingRateAsc":
        this.setState({ reducingRateAscending: true }, () => {
          this.reducingRateSort();
        });
        break;
      case "ReducingRateDesc":
        this.setState({ reducingRateAscending: false }, () => {
          this.reducingRateSort();
        });
        break;
      default:
        break;
    }
    localStorage.setItem("sortValue", value);
  };

  render() {
    const { sortValue } = this.state;
    const lang = getStaticText(this.props.activeLanguage);
    const { carLoanTypeList } = getConst(this.props.activeLanguage);
    const { genericFormIds } = getConst(this.props.activeLanguage);

    let cardDetailsToDisplay = [];
    console.log("Details:", this.props.cardDetails);
    console.log("Props:", this.props);
    if (!_.isEmpty(this.props.cardDetails)) {
      cardDetailsToDisplay = _.take(
        this.props.cardDetails,
        this.state.numberOfCardToShow
      );
    }
    // let stepValue;
    // if(this.state.carPrice < 200000){
    //   stepValue = 5000;
    // }else if (this.state.carPrice >= 200000) {
    //   stepValue = 25000;
    // }
    const { activeIndex } = this.state;
    const sortOptions = [
      {
        text: "Min Salary Low to high",
        key: "Min Salary Low to high",
        value: "minimumSalaryAsc",
      },
      {
        key: "Min Salary High to Low",
        text: "Min Salary High to Low",
        value: "minimumSalaryDesc",
      },
      {
        key: "Fixed Rate Low to high",
        text: "Fixed Rate Low to high",
        value: "FixedRateAsc",
      },
      {
        key: "Fixed Rate High to Low",
        text: "Fixed Rate High to Low",
        value: "FixedRateDesc",
      },
      {
        key: "Reducing Rate Low to high",
        text: "Reducing Rate Low to high",
        value: "ReducingRateAsc",
      },
      {
        key: "Reducing Rate High to Low",
        text: "Reducing Rate High to Low",
        value: "ReducingRateDesc",
      },
    ];
    return (
      <div className="credit-home-page">
        {autoLoanTag.map((row, idx) =>
          this.props.location.pathname === row.path ? (
            <Helmet key={idx}>
              <title>{row.title}</title>
              <meta name="description" content={row.description} />
              {window.location.href ===
              "http://staging.soulwallet.com" + this.props.location.pathname ? (
                <meta name="robots" content="noindex, nofollow" />
              ) : (
                <meta name="robots" content="all, index, follow" />
              )}
              <link
                href={
                  "https://www.soulwallet.com" + this.props.location.pathname
                }
                rel="canonical"
              />
            </Helmet>
          ) : (
            <Helmet key={idx}></Helmet>
          )
        )}
        {carLoanTypeList.map((row, idx) =>
          this.props.location.pathname === row.path ? (
            <Helmet key={idx}>
              <script type="application/ld+json">
                {`{
                  "@context": "https://schema.org/",
                  "@type": "BreadcrumbList",
                  "itemListElement": [{
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Home",
                    "item": "https://www.soulwallet.com"
                  },{
                    "@type": "ListItem",
                    "position": 2,
                    "name": "Car Loans",
                    "item": "https://www.soulwallet.com/car-loans"
                  },{
                    "@type": "ListItem",
                    "position": 3,
                    "name": "${row.type}",
                    "item": "https://www.soulwallet.com${row.path}"
                  }]
                }`}
              </script>
            </Helmet>
          ) : (
            ""
          )
        )}
        {/* <Helmet>
          <title>Compare and Apply for the Best Auto Loans in UAE - Soulwallet</title>
          <meta name="description" content="Soulwallet helps you Find the Best and Quick Auto loans with minimum documentation and attractive Interest rates. Easy and Seamless Process.Apply Now!" />
          <link rel="canonical" href="www.soulwallet.com/car-loans" />
        </Helmet> */}
        <BannerAutoLoan
          activeLanguage={this.props.activeLanguage}
          location={this.props.location}
        />
        <div
          className={
            _.isEmpty(this.props.compareCards)
              ? "panel-compare hide"
              : "panel-compare compare-sticky"
          }
        >
          <div className="panel-compare-inner">
            <Card.Group>
              <h5>{lang.max_compare_card_msg}</h5>
              {this.props.compareCards.map((row, idx) => (
                <Card
                  key={idx}
                  className="animated bounceInRight"
                  id={`card-box-${row.id}`}
                >
                  <Card.Content>
                    <Image
                      alt={row.bankName + " " + row.name}
                      size="small"
                      src={row.logo}
                    />
                    <Button
                      icon="remove"
                      value={row.id}
                      onClick={this.removeCompareCard}
                    ></Button>
                    <Card.Description>
                      <span className="card-name">{row.bankName}</span>{" "}
                      <strong>{row.name}</strong>
                    </Card.Description>
                  </Card.Content>
                </Card>
              ))}
            </Card.Group>
            {this.props.compareCards.length > 1 &&
            this.props.compareCards.length < 5 ? (
              <Button
                className="btn btn-blue-compare"
                onClick={this.compareCardsPopup}
              >
                {lang.compare + lang.auto_loans}(
                {this.props.compareCards.length})
              </Button>
            ) : (
              ""
            )}
            <Button
              className="btn btn-link btn-reset"
              onClick={this.resetCompareCard}
            >
              <Icon name="close" />
            </Button>
          </div>
        </div>

        <div
          className={
            _.isEmpty(this.props.compareCards) ||
            this.props.compareCards.length < 2
              ? "panel-compare hide"
              : "panel-compare compare-sticky panel-compare--mobile"
          }
        >
          <div className="panel-compare-inner">
            {this.props.compareCards.length > 1 &&
            this.props.compareCards.length < 5 ? (
              <Button className="btn btn-blue" onClick={this.compareCardsPopup}>
                {lang.compare} {lang.auto_loans} (
                {this.props.compareCards.length})
              </Button>
            ) : (
              ""
            )}
            <Button
              onClick={this.resetCompareCard}
              className="btn btn-link btn-reset"
            >
              <Icon name="close" />
            </Button>
          </div>
        </div>
        <CardCompare
          data={{
            comparePopupClose: this.compareCardsPopup,
            popupOpen: this.state.compareCardsPopup,
            compareCards: this.props.compareCards,
            removeCompareCard: this.removeCompareCard,
            applyFlag: this.state.applyFlag,
            applyCreditCard: this.applyCreditCard,
            cardObjectForSearch: this.state.cardObjectForSearch,
            onCompareCardSearchChange: this.onCompareCardSearchChange,
            closeApplyFormInCompare: this.closeApplyFormInCompare,
            toggleVisibilityForPdp: this.toggleVisibilityForPdp,
            compareSimulatePopup: this.compareSimulatePopup,
            handleMultipleApplyCard: this.handleMultipleApplyCard,
            applyCards: this.state.applyCards,
            applyCardChecked: this.state.applyCardChecked,
            applyDirect: this.applyDirect,
            cardDetailsLength: this.props.cardDetails.length,
          }}
        />

        <div className="sw-layout">
          <div className="sw-content">
            <br />
            <GeneralForm
              data={{
                applyId: genericFormIds.carLoan,
              }}
            ></GeneralForm>
            <Segment.Group
              className="ui basic segment sw-panel sw-panel--loans sw-panel--loans-auto sw-panel--loans-car"
              horizontal
            >
              <div className="sw-panel-left">
                <div className="loan-mobile-sticky">
                  <div
                    className="js-filter-box filter-btn-primary show-for-small"
                    onClick={() => {
                      this.setState({
                        make_tip_visible: !this.state.make_tip_visible,
                      });
                    }}
                  >
                    <h5 className="panel-title filter-auto-loan">
                      <Icon name="filter" /> {lang.filter_by}
                      <span className="show-for-small-inline">
                        (
                        {_.add(
                          this.props.filterAttribute.selectedBanks.length,
                          _.add(
                            !_.isEmpty(
                              this.props.filterAttribute.selectedCardType
                            ),
                            _.add(
                              this.props.filterAttribute.selectedFeatures
                                .length,
                              !_.isEmpty(
                                this.props.filterAttribute.selectedCarType
                              )
                            )
                          )
                        )}
                        )
                      </span>
                    </h5>
                    <h5 className="panel-title js-auto-loan-simulate show-for-xs">
                      <Icon name="calculator" />
                      {lang.simulate_loan_emi}
                    </h5>
                  </div>
                </div>
                <Filter
                  make_tip_visible={this.state.make_tip_visible}
                  sortAfterFilter={this.sortAfterFilter}
                />
                <div className="show-for-small filter-cta-apply">
                  <Button className="btn btn-blue">{lang.submit}</Button>
                </div>
              </div>
              <div className="sw-panel-wrap">
                {/* <!-- Start of Simulator --> */}
                <div className="simulator-loans auto-simulator">
                  <h5 className="panel-header--title">
                    {lang.simulate_your_auto_loan_emi}
                  </h5>
                  <div className="sim-1">
                    <div className="simulator-loans--box simulator-car-price">
                      <span className="title">
                        {lang.car_price} ({lang.aed})
                      </span>
                      <div className="slider-container">
                        <Slider
                          // step={stepValue}
                          step={5000}
                          value={this.state.carPrice}
                          min={0}
                          max={1000000}
                          onChange={this.onCarPriceChange}
                          className="rc-slider--carloans"
                          tabIndex={-1}
                        />
                        <div className="label custom-placeholder">
                          <Form.Input
                            name="carPrice"
                            onChange={this.handleCarInputChange}
                            value={
                              this.state.carPrice > 0
                                ? accounting.formatMoney(
                                    this.state.carPrice,
                                    "",
                                    0
                                  )
                                : ""
                            }
                            max={1000000}
                            className="value"
                            type="text"
                            onKeyPress={this.digitValidate}
                            placeholder={"0"}
                            onFocus={(e) => (e.target.placeholder = "")}
                            onBlur={(e) => (e.target.placeholder = "0")}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="simulator-loans--box simulator-down-payment">
                      <div className="title-percentage">
                        <span className="title">{lang.down_payment}</span>
                        <span className="percentage">
                          {this.state.downPayment} %
                        </span>
                      </div>
                      <div className="slider-container">
                        <Slider
                          step={0.25}
                          value={this.state.downPayment}
                          min={0}
                          max={100}
                          onChange={this.onDownPaymentChange}
                          className="rc-slider--carloans"
                          tabIndex={-1}
                          placeholder={"0.00"}
                          onFocus={(e) => (e.target.placeholder = "")}
                          onBlur={(e) => (e.target.placeholder = "0.00")}
                        />
                        <div className="label custom-placeholder">
                          <Form.Input
                            name="down-payment"
                            onChange={this.handleCarInputChange}
                            value={accounting.formatMoney(
                              this.state.downPaymentAmount,
                              "",
                              0
                            )}
                            max={60}
                            className="value"
                            type="text"
                            onKeyPress={this.digitValidate}
                            placeholder={"0"}
                            onFocus={(e) => (e.target.placeholder = "")}
                            onBlur={(e) => (e.target.placeholder = "0")}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="simulator-loans--box simulator-loan-amount">
                      <span className="title">
                        {lang.loan_amount} ({lang.aed})
                      </span>
                      <div className="label custom-placeholder">
                        <Form.Input
                          name="loanRequired"
                          onChange={this.handleLoanInputChange}
                          value={accounting.formatMoney(
                            this.state.loanAmount,
                            "",
                            0
                          )}
                          max={1000000}
                          className="value"
                          type="text"
                          onKeyPress={this.digitValidate}
                          placeholder={"0"}
                          onFocus={(e) => (e.target.placeholder = "")}
                          onBlur={(e) => (e.target.placeholder = "0")}
                        />
                      </div>
                    </div>
                    {/* <div className='simulator-loans--box simulator-property-type hide-for-xs'>
                      <span className='title'>{lang.loan_amount} ({lang.aed})</span>
                      <Dropdown
                        value={this.state.propertyType}
                        selection
                        options={mortgagePropertyType}
                        name='propertyType'
                        onChange={this.handleDropdownChange}
                        search={false}
                      />
                    </div>
                    <div className='simulator-loans--box simulator-nationality hide-for-xs'>
                      <span className='title'>{lang.nationality}</span>
                      <Dropdown
                        value={this.state.nationality}
                        selection
                        options={nationality}
                        name='nationality'
                        onChange={this.handleDropdownChange}
                        search={false}
                      />
                    </div> */}
                  </div>
                  <div className="sim-2">
                    <div className="simulator-loans--box simulator-loans--box-term">
                      <span className="title">
                        {lang.term} ({lang.months})
                      </span>
                      <div className="slider-container">
                        <Slider
                          step={6}
                          value={this.state.term}
                          min={0}
                          max={60}
                          onChange={this.onTermChange}
                          className="rc-slider--carloans"
                          tabIndex={-1}
                        />
                        <div className="label custom-placeholder">
                          <Form.Input
                            name="term"
                            onChange={this.handleCarInputChange}
                            value={this.state.term > 0 ? this.state.term : ""}
                            max={60}
                            className="value"
                            type="number"
                            onKeyPress={this.digitValidate}
                            placeholder={"0"}
                            onFocus={(e) => (e.target.placeholder = "")}
                            onBlur={(e) => (e.target.placeholder = "0")}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="simulator-loans--email">
                      {this.props.allowInput ? (
                        <div className="form-control car-email">
                          <Form.Input
                            name="simulateEmail"
                            onChange={this.handleSimulateEmailChange}
                            value={this.state.simulateEmail}
                            placeholder={lang.email_placeholder}
                          />
                          <span className="input-error">
                            {this.state.simulateEmailError}
                          </span>
                        </div>
                      ) : (
                        <div className="form-control form-control--email">
                          <span className="email-edit-icon">
                            <div className="email-overflow">
                              {this.props.simulateEmail}
                            </div>
                            <Button
                              onClick={this.editSimulateEmail}
                              className="email-edit-icon"
                            >
                              <Icon name="pencil" />
                            </Button>
                          </span>
                        </div>
                      )}
                    </div>
                    <div className="personal-btn">
                      <Button
                        className={
                          this.state.disableEmiCalculateButton
                            ? "hide"
                            : "btn-ornage simulator-loans--cta hide-for-xs"
                        }
                        id="simulator-autoloans"
                        onClick={this.calculateEmi}
                        disabled={
                          this.state.carPrice < 1 ||
                          this.state.term < 1 ||
                          !(
                            !_.isEmpty(this.state.simulateEmail) ||
                            !_.isEmpty(this.props.simulateEmail)
                          )
                        }
                        content={lang.calculate}
                      />
                      <Button
                        className={
                          this.state.disableEmiCalculateButton
                            ? "hide"
                            : "simulator-loans--cta show-for-xs"
                        }
                        id="simulator-autoloans"
                        onClick={this.calculateEmi}
                        disabled={
                          this.state.carPrice < 1 ||
                          this.state.term < 1 ||
                          !(
                            !_.isEmpty(this.state.simulateEmail) ||
                            !_.isEmpty(this.props.simulateEmail)
                          )
                        }
                        content={lang.submit}
                      />
                    </div>
                  </div>
                </div>
                {/* <!-- End of Simulator --> */}
                <a
                  href="https://www.soulwallet.com/car-loans/details/emirates-islamic-green-auto-finance/418"
                  className="image_wrap"
                  target="_blank"
                >
                  <img
                    className="lazyload hide-for-xs"
                    alt="citibank_emirates_banner"
                    data-src="../../assets/Emirate_Islamic_Auto_Desktop.webp"
                  />
                  <img
                    className="lazyload show-for-xs"
                    alt="citibank_emirates_banner"
                    data-src="../../assets/Emirate_Islamic_Auto_Mobile.webp"
                  />
                </a>
                <div className="sw-panel-right">
                  {/* <Breadcrumb>
                    <Breadcrumb.Section><a href='/'>Home</a></Breadcrumb.Section>
                    <Breadcrumb.Divider />
                    <Breadcrumb.Section>Car Loans</Breadcrumb.Section>
                  </Breadcrumb> */}
                  <Breadcrumb>
                    <Breadcrumb.Section>
                      <a href="/">Home</a>
                    </Breadcrumb.Section>
                    <Breadcrumb.Divider />
                    <Breadcrumb.Section>
                      <a href="/car-loans">Car Loans</a>
                    </Breadcrumb.Section>
                    {carLoanTypeList.map((row, idx) =>
                      this.props.location.pathname === row.path ? (
                        <React.Fragment>
                          {row.path === "/car-loans" ? (
                            <Breadcrumb.Section></Breadcrumb.Section>
                          ) : (
                            <React.Fragment>
                              <Breadcrumb.Divider />
                              <Breadcrumb.Section key={idx}>
                                {row.type}
                              </Breadcrumb.Section>
                            </React.Fragment>
                          )}
                        </React.Fragment>
                      ) : (
                        ""
                      )
                    )}
                  </Breadcrumb>
                  <div className="filter-results show-for-small">
                    {this.props.filterAttribute.onlyContract === true ? (
                      <Label>
                        {lang.contract_text}
                        <Button
                          icon="remove"
                          value=""
                          name="contract"
                          onClick={this.changeFilterAttribute}
                        ></Button>
                      </Label>
                    ) : (
                      ""
                    )}
                  </div>
                  <div
                    className={
                      this.props.filterAttribute.onlyContract === true
                        ? "panel-header panelTop"
                        : "panel-header"
                    }
                  >
                    {this.props.gotAutoLoanDataFromApi &&
                      carLoanTypeList.map((row, idx) =>
                        this.props.location.pathname === row.path ? (
                          <div>
                            <h1 className="panel-header--title">{row.type}</h1>
                            {_.isEmpty(this.state.searchQuery) ? (
                              <span className="panel-header--count">
                                {" "}
                                (
                                {this.props.cardDetails.length > 1
                                  ? `${this.props.cardDetails.length} ${lang.results_found}`
                                  : `${this.props.cardDetails.length} ${lang.result_found}`}
                                )
                              </span>
                            ) : (
                              <span>
                                &nbsp; 1-{cardDetailsToDisplay.length} {lang.of}{" "}
                                {this.props.cardDetails.length}{" "}
                                {lang.results_for} "{this.state.searchQuery}"
                                <span
                                  className="search-clear-result right"
                                  onClick={this.clearSearchResult}
                                >
                                  {_.isEmpty(this.state.searchQuery) ? (
                                    ""
                                  ) : (
                                    <i className="icon close" />
                                  )}{" "}
                                </span>
                              </span>
                            )}
                          </div>
                        ) : (
                          ""
                        )
                      )}

                    {this.props.gotAutoLoanDataFromApi &&
                    this.props.location.pathname === "/car-loans" ? (
                      <div>
                        <h1 className="panel-header--title">{lang.car_head}</h1>
                        {_.isEmpty(this.state.searchQuery) ? (
                          <span className="panel-header--count">
                            {" "}
                            (
                            {this.props.cardDetails.length > 1
                              ? `${this.props.cardDetails.length} ${lang.results_found}`
                              : `${this.props.cardDetails.length} ${lang.result_found}`}
                            )
                          </span>
                        ) : (
                          <span>
                            &nbsp; 1-{cardDetailsToDisplay.length} {lang.of}{" "}
                            {this.props.cardDetails.length} {lang.results_for} "
                            {this.state.searchQuery}"
                            <span
                              className="search-clear-result right"
                              onClick={this.clearSearchResult}
                            >
                              {_.isEmpty(this.state.searchQuery) ? (
                                ""
                              ) : (
                                <i className="icon close" />
                              )}{" "}
                            </span>
                          </span>
                        )}
                      </div>
                    ) : (
                      ""
                    )}

                    <div className="sort-dropdown">
                      <span className="sort-drop-span">Sort</span>
                      <Dropdown
                        className=""
                        compact
                        selection
                        options={sortOptions}
                        value={sortValue}
                        onChange={this.onChangeSort}
                      />
                    </div>

                    {this.state.sortBy === "minimumSalary" ||
                    this.state.sortBy === "fixedRate" ||
                    this.state.sortBy === "reducingRate" ? (
                      <span className="sort-icon-option">
                        {this.state.sortBy === "minimumSalary" ? (
                          this.state.minimumSalaryAscending ? (
                            <i
                              onClick={
                                this.state.sortBy === "minimumSalary"
                                  ? this.minimumSalarySort
                                  : null
                              }
                              className="sort descending icon"
                            ></i>
                          ) : (
                            <i
                              onClick={
                                this.state.sortBy === "minimumSalary"
                                  ? this.minimumSalarySort
                                  : null
                              }
                              className="sort ascending icon"
                            ></i>
                          )
                        ) : null}
                        {this.state.sortBy === "fixedRate" ? (
                          this.state.fixedRateAscending ? (
                            <i
                              onClick={
                                this.state.sortBy === "fixedRate"
                                  ? this.fixedRateSort
                                  : null
                              }
                              className="sort descending icon"
                            ></i>
                          ) : (
                            <i
                              onClick={
                                this.state.sortBy === "fixedRate"
                                  ? this.fixedRateSort
                                  : null
                              }
                              className="sort ascending icon"
                            ></i>
                          )
                        ) : null}
                        {this.state.sortBy === "reducingRate" ? (
                          this.state.reducingRateAscending ? (
                            <i
                              onClick={
                                this.state.sortBy === "reducingRate"
                                  ? this.reducingRateSort
                                  : null
                              }
                              className="sort descending icon"
                            ></i>
                          ) : (
                            <i
                              onClick={
                                this.state.sortBy === "reducingRate"
                                  ? this.reducingRateSort
                                  : null
                              }
                              className="sort ascending icon"
                            ></i>
                          )
                        ) : null}
                      </span>
                    ) : this.props.appliedEmiForAutoLoans ? (
                      <span className="sort-icon-option">
                        {this.state.emiAscending ? (
                          <i
                            onClick={
                              this.state.sortBy === "emi" ? this.emiSort : null
                            }
                            className="sort descending icon"
                          ></i>
                        ) : (
                          <i
                            onClick={
                              this.state.sortBy === "emi" ? this.emiSort : null
                            }
                            className="sort ascending icon"
                          ></i>
                        )}
                      </span>
                    ) : null}

                    <Dropdown className="sort-option" text="Sort">
                      <Dropdown.Menu>
                        <Dropdown.Item
                          className={
                            this.state.sortBy === "minimumSalary"
                              ? "active"
                              : null
                          }
                          onClick={this.minimumSalarySort}
                          text="Monthly Salary"
                        />
                        <Dropdown.Item
                          className={
                            this.state.sortBy === "fixedRate" ? "active" : null
                          }
                          onClick={this.fixedRateSort}
                          text="Fixed Rate"
                        />
                        <Dropdown.Item
                          className={
                            this.state.sortBy === "reducingRate"
                              ? "active"
                              : null
                          }
                          onClick={this.reducingRateSort}
                          text="Reducing Rate"
                        />
                        {this.props.appliedEmiForAutoLoans ? (
                          <Dropdown.Item
                            className={
                              this.state.sortBy === "emi" ? "active" : null
                            }
                            onClick={this.emiSort}
                            text="EMI"
                          />
                        ) : null}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  {/* <div className='filter-results show-for-xs'>
                    {_.has(this.props.filterAttribute, 'noAnnualFee') && this.props.filterAttribute.noAnnualFee ?
                      <Label>{this.props.filterAttribute.selectedCardType}{"No " + lang.annual_fee}
                        <Button icon='remove' value={lang.annual_fee} name='noAnnualFee' onClick={this.changeFilterAttribute}></Button>
                      </Label>
                      :
                      ''
                    }
                    {_.isEmpty(this.props.filterAttribute.selectedBanks) ? '' :
                      this.props.filterAttribute.selectedBanks.map((item, idx) => (
                        <Label key={idx}>{item}
                          <Button icon='remove' value={item} name='bank' onClick={this.changeFilterAttribute}></Button>
                        </Label>
                      ))}
                    {_.isEmpty(this.props.filterAttribute.selectedCardType) ? '' :

                      <Label>{this.props.filterAttribute.selectedCardType}
                        <Button icon='remove' value={this.props.filterAttribute.selectedCardType} name='type' onClick={this.changeFilterAttribute}></Button>
                      </Label>
                    }
                    {_.isEmpty(this.props.filterAttribute.selectedFeatures) ? '' :

                      this.props.filterAttribute.selectedFeatures.map((item, idx) => (
                        <Label key={idx}>{item}
                          <Button icon='remove' value={item} name='feature' onClick={this.changeFilterAttribute}></Button>
                        </Label>
                      ))}
                    {this.props.filterAttribute.premium === 'yes' ?
                      <Label>{lang.premium}
                        <Button icon='remove' value='' name='premium' onClick={this.changeFilterAttribute}></Button>
                      </Label>
                      : ''}
                    {this.props.filterAttribute.onlyContract === true ?
                      <Label>{lang.contract_text}
                        <Button icon='remove' value='' name='contract' onClick={this.changeFilterAttribute}></Button>
                      </Label>
                      : ''}
                    {!_.isEmpty(this.props.filterAttribute.selectedBanks) ||
                      !_.isEmpty(this.props.filterAttribute.selectedCardType) ||
                      !_.isEmpty(this.props.filterAttribute.selectedFeatures) ||
                      !_.isEmpty(this.props.filterAttribute.premium) ||
                      this.props.filterAttribute.onlyContract ||
                      this.props.filterAttribute.noAnnualFee
                      ? <Button className='filter-clear-cta' onClick={this.clearAllFilter}>{lang.clear_all}</Button> : <span></span>}
                  </div> */}
                  <div
                    className={
                      this.props.appliedEmiForAutoLoans
                        ? "table-responsive card-details emi-applied simulator-applied"
                        : "table-responsive card-details"
                    }
                  >
                    <div className="table">
                      {this.props.gotAutoLoanDataFromApi ? (
                        <div className="table-head">
                          {/* <div className='table-row'>
                    <div className='table-column card-name'>
                      <span>{lang.loan_provider}</span>
                    </div>
                    <div className={this.state.sortBy=== 'maxLoanAmount'?'table-column card-salary sorted':'table-column card-salary'}>
                      <span>{lang.loan_amount}
                        {this.state.sortBy=== 'maxLoanAmount'?
                          <Button icon onClick={this.maxLoanAmountSort}><i className={!this.state.maxLoanAmountAscending?"ascending icon sort":"sort descending icon"}></i>
                          </Button>:
                          <Button icon onClick={this.maxLoanAmountSort}><i className='sort icon'></i></Button>
                        }
                      </span>
                    </div>
                    <div className={this.state.sortBy === 'downPayment'?'table-column card-min-sal sorted':'table-column card-min-sal'}>
                      <span>{lang.down_payment}
                        {this.state.sortBy === 'downPayment'?
                          <Button icon onClick={this.downPaymentSort}><i className={!this.state.downPaymentAscending?"ascending icon sort":"sort descending icon"}></i>
                          </Button>:
                          <Button icon onClick={this.downPaymentSort}><i className='sort icon'></i></Button>
                        }
                      </span>
                    </div>
                    {this.props.appliedEmiForAutoLoans?<div className={this.state.sortBy=== 'emi'?'table-column card-emi sorted':'table-column card-emi'}>
                        <span>{lang.emi}
                          {this.state.sortBy=== 'emi'?
                            <Button icon onClick={this.emiSort}><i className={!this.state.emiAscending?"ascending icon sort":"sort descending icon"}></i>
                            </Button>:
                            <Button icon onClick={this.emiSort}><i className='sort icon'></i></Button>
                          }
                        </span>
                    </div>:''}

                    <div className={this.state.sortBy === 'fixedRate'?'table-column card-annual-fee sorted':'table-column card-annual-fee'}>
                      <span>{lang.fixed_rate}
                        {this.state.sortBy === 'fixedRate'?
                          <Button icon onClick={this.fixedRateSort}><i className={!this.state.fixedRateAscending?"ascending icon sort":"sort descending icon"}></i>
                          </Button>:
                          <Button icon onClick={this.fixedRateSort}><i className='sort icon'></i></Button>
                        }
                      </span>
                    </div>
                    <div className={this.state.sortBy === 'reducingRate'?'table-column card-rate sorted':'table-column card-rate'}>
                      <span>{lang.reducing_rate}
                        {this.state.sortBy === 'reducingRate'?
                          <Button icon onClick={this.reducingRateSort}><i className={!this.state.reducingRateAscending?"ascending icon sort":"sort descending icon"}></i>
                          </Button>:
                          <Button icon onClick={this.reducingRateSort}><i className='sort icon'></i></Button>
                        }
                      </span>
                    </div>
                    {!this.props.appliedEmiForAutoLoans?<div className='table-column card-reasons'>
                      <span>{lang.top_reason_to_choose}</span>
                    </div>:''}
                  </div> */}
                        </div>
                      ) : (
                        ""
                      )}
                      <div className="table-body">
                        {!this.props.gotAutoLoanDataFromApi ? (
                          <div>
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />

                            <div className="flower-spinner">
                              <div className="dots-container">
                                <div className="bigger-dot">
                                  <div className="smaller-dot"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}

                        {!_.isEmpty(cardDetailsToDisplay) ? (
                          cardDetailsToDisplay.map((row, index) => {
                            let minimumSalary = accounting
                              .formatMoney(row.minimumSalary, lang.aed_format)
                              .split(" ");
                            let emi;
                            let maxLoanAmount;
                            if (
                              this.state.loanAmount >= row.maxLoanAmount ||
                              this.state.loanAmount === 0
                            )
                              maxLoanAmount = accounting
                                .formatMoney(row.maxLoanAmount, lang.aed_format)
                                .split(" ");
                            else
                              maxLoanAmount = accounting
                                .formatMoney(
                                  this.state.loanAmount,
                                  lang.aed_format
                                )
                                .split(" ");

                            if (
                              row.maxLoanAmount === null ||
                              row.maxLoanAmount === 0 ||
                              row.fixedRate === 0
                            ) {
                              emi = [" ", "NA "];
                            } else {
                              emi = accounting
                                .formatMoney(row.emi, lang.aed_format)
                                .split(" ");
                            }
                            row.cardname = (row.bankName + "-" + row.name)
                              .replace(/\s+/g, "-")
                              .toLowerCase();
                            row.idname =
                              row.name.replace(/\s+/g, "_").toLowerCase() +
                              "_apply_now";

                            return [
                              <div
                                className="table-row auto-remove-b-r tab-fix-car-col"
                                key={index}
                              >
                                <div className="table-column card-name show-for-desktop">
                                  <div className="card-img-out">
                                    <div className="card-img">
                                      <Link
                                        target="_blank"
                                        to={`/car-loans/details/${row.cardname}/${row.id}`}
                                      >
                                        <Image
                                          alt={row.bankName + " " + row.name}
                                          src={row.logo + lang.auto_compress}
                                          size="tiny"
                                        />
                                      </Link>
                                    </div>
                                    <div className="card-links">
                                      <Link
                                        target="_blank"
                                        to={`/car-loans/details/${row.cardname}/${row.id}`}
                                      >
                                        <span>{row.bankName}</span>
                                      </Link>
                                    </div>
                                    <div className="card-img-name">
                                      <Link
                                        target="_blank"
                                        to={`/car-loans/details/${row.cardname}/${row.id}`}
                                        className="card-name"
                                      >
                                        {row.name}
                                      </Link>
                                      {/* <Rating className="show-for-small" icon='star' maxRating={5} rating={row.rating} size='tiny' disabled /><span className='rating-count show-for-small'>({row.numberOfReviews})</span> */}
                                    </div>
                                  </div>
                                </div>
                                {/* <div className='table-column card-name show-for-small'>
                      <div className='card-img-out'>
                        <div className='card-img'>
                          <Link to={`/car-loans/details/${row.cardname}/${row.id}`}>
                            <Image alt={lang.auto_loan} src={row.logo+lang.auto_compress} size='tiny' />
                          </Link>
                        </div>
                        <div className='card-links'>
                          <Link to={`/car-loans/details/${row.cardname}/${row.id}`}><span>{row.bankName}</span></Link>
                        </div>
                        <div className='card-img-name'>
                        <Link to={`/car-loans/details/${row.cardname}/${row.id}`} className='card-name'>{row.name}</Link>
                          <Rating icon='star' maxRating={5} rating={row.rating} size='tiny' disabled /><span className='rating-count'>({row.numberOfReviews})</span>
                        </div>
                        </div>
                      </div> */}

                                <div
                                  className={
                                    !this.props.appliedEmiForAutoLoans
                                      ? "col-divider"
                                      : "col-divider active"
                                  }
                                >
                                  {/* <div className={!this.props.appliedEmiForAutoLoans?'table-column card-salary padding-top-35':'table-column card-salary padding-top-65'}>
                          <span className='show-for-small text-gray'>{lang.loan_amount}</span>
                          {maxLoanAmount[1]+" "}<span className='text-bold'>{maxLoanAmount[0]}</span>
                        </div> */}
                                  {/* <div className={!this.props.appliedEmiForAutoLoans?'table-column card-min-sal padding-top-35':'table-column card-min-sal padding-top-65'}>
                          <span className='show-for-small text-gray'>{lang.down_payment}</span>
                          <span className='text-bold'>{row.downPayment.toFixed(2)}%</span>
                        </div> */}
                                  {/* {this.props.appliedEmiForAutoLoans?<div className='table-column card-emi padding-top-55'>
                          <span className='show-for-small text-gray'>{lang.emi} ({lang.monthly})</span>
                          <span className='badge-primary'>{emi[1]+" "}<span className="text-bold">{emi[0]}</span></span>
                        </div>:''} */}

                                  <div
                                    className={
                                      !this.props.appliedEmiForAutoLoans
                                        ? "table-column card-rate"
                                        : "table-column card-rate"
                                    }
                                  >
                                    <div className="rate-1">
                                      <h4>{lang.minimum_salary}</h4>
                                      <p className="text-bold">
                                        {minimumSalary[1] + " "}
                                        <span>{minimumSalary[0]}</span>
                                      </p>
                                    </div>
                                    <div className="rate-1">
                                      <h4>{row.id === 773 ? 'FINANCE AMOUNT' : lang.loan_amount }</h4>
                                      <p className="text-bold">
                                        {maxLoanAmount[1] + " "}
                                        <span>{maxLoanAmount[0]}</span>
                                      </p>
                                    </div>
                                    <div className="rate-1">
                                      <h4>{lang.down_payment}</h4>
                                      <span className="text-bold">
                                        {row.downPayment.toFixed(2)}%
                                      </span>
                                    </div>
                                    <div className="rate-1 show-for-small">
                                      <h4>
                                        {row.id === 707
                                          ? "Flat Rate"
                                          : lang.fixed_rate}
                                      </h4>
                                      <p className="text-bold">
                                        {row.fixedRate.toFixed(2)} %
                                      </p>
                                    </div>
                                    <div className="rate-1 show-for-small">
                                      <h4>{lang.reducing_rate}</h4>
                                      <p className="text-bold">
                                        {row.reducingRate.toFixed(2)} %
                                      </p>
                                    </div>
                                    {this.props.appliedEmiForAutoLoans ? (
                                      <div className="rate-1 tab-emi show-for-small">
                                        <h4>
                                          {lang.emi} ({lang.monthly})
                                        </h4>
                                        <span className="badge-primary text-bold">
                                          {emi[1] + " "}
                                          <span className="text-bold">
                                            {emi[0]}
                                          </span>
                                        </span>
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </div>
                                <div className="table-column card-annual-fee hide-for-xs">
                                  <div className="rate-1">
                                    <h4>
                                      {row.id === 707
                                        ? "Flat Rate"
                                        : lang.fixed_rate}
                                    </h4>
                                    <p className="text-bold">
                                      {row.fixedRate.toFixed(2)} %
                                    </p>
                                  </div>
                                  <div className="rate-1">
                                    <h4>{lang.reducing_rate}</h4>
                                    <p className="text-bold">
                                      {row.reducingRate.toFixed(2)} %
                                    </p>
                                  </div>
                                  {this.props.appliedEmiForAutoLoans ? (
                                    <div className="rate-1 tab-emi">
                                      <h4>
                                        {lang.emi} ({lang.monthly})
                                      </h4>
                                      <span className="badge-primary text-bold">
                                        {emi[1] + " "}
                                        <span className="text-bold">
                                          {emi[0]}
                                        </span>
                                      </span>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                                <div className="table-column card-reasons">
                                  <h4>TOP REASONS TO CHOOSE</h4>
                                  <ul className="table-reasons">
                                    {row.topReasons.map((item, idx) => (
                                      <li key={idx}>{_.upperFirst(item)}</li>
                                    ))}
                                  </ul>
                                </div>
                                <div
                                  className="tr-row"
                                  key={index + cardDetailsToDisplay.length}
                                >
                                  <div className="" colSpan="6">
                                    <div className="panel-quick-view">
                                      <Segment className="ui basic segment">
                                        <Accordion>
                                          <div className="features-panel">
                                            <Accordion.Title
                                              active={
                                                this.state
                                                  .activeQuickViewIndex ===
                                                index
                                              }
                                              cardid={row.id}
                                              index={index}
                                              onClick={
                                                this.handleQuickViewClick
                                              }
                                              className="bold color-blue"
                                              id={"QuickView-" + row.name}
                                            >
                                              <span>{lang.quick_view}</span>
                                              <Icon
                                                style={{ marginLeft: "5px" }}
                                                fitted
                                                name="dropdown"
                                                color="blue"
                                              />
                                            </Accordion.Title>

                                            {cardDetailsToDisplay.length > 0 ? (
                                              <Checkbox
                                                className="checkbox custom-checkbox"
                                                id={
                                                  "Compare-" +
                                                  row.bankName +
                                                  row.name
                                                }
                                                disabled={
                                                  !(
                                                    _.has(
                                                      this.props.compareChecked,
                                                      row.id
                                                    ) &&
                                                    this.props.compareChecked[
                                                      row.id
                                                    ]
                                                  ) &&
                                                  this.props.compareCards
                                                    .length === 4
                                                    ? true
                                                    : false
                                                }
                                                label={lang.compare}
                                                value={row.id}
                                                onChange={
                                                  this.handleCompareCard
                                                }
                                                checked={
                                                  _.has(
                                                    this.props.compareChecked,
                                                    row.id
                                                  ) &&
                                                  this.props.compareChecked[
                                                    row.id
                                                  ]
                                                }
                                              />
                                            ) : (
                                              ""
                                            )}

                                            <div className="card-compare-chkbx">
                                              <Button
                                                className="btn btn-blue"
                                                id={row.idname}
                                                cardid={row.id}
                                                onClick={this.applyDirect}
                                              >
                                                {lang.apply}
                                              </Button>

                                              {/* {row.contract?
                                  <Button className='btn btn-blue' id={row.idname} cardid={row.id} onClick={this.applyDirect}>{lang.apply}</Button>:
                                  <span className='applyBtn right' title={row.contract? '':lang.non_contract_alert_less}>
                                    <Button className='btn btn-blue disabled'id={row.idname} title={lang.non_contract_alert_less} cardid={row.id}>{lang.apply}</Button>
                                  </span>
                                } */}
                                            </div>
                                          </div>
                                          <Accordion.Content
                                            active={
                                              this.state
                                                .activeQuickViewIndex === index
                                            }
                                          >
                                            <Segment.Group
                                              horizontal
                                              className="quick-view-content"
                                            >
                                              <Segment>
                                                <Segment.Group className="ui basic segment fromEditor">
                                                  <Segment className="quick-details-a show-for-desktop">
                                                    <span>
                                                      <span>
                                                        <p>
                                                          {
                                                            lang.minimum_salary_required
                                                          }
                                                          <span className="right bold color-blue">
                                                            {accounting.formatMoney(
                                                              row.minimumSalary,
                                                              `${lang.aed} `,
                                                              0
                                                            )}
                                                          </span>
                                                        </p>
                                                      </span>
                                                      <span>
                                                        <p>
                                                          {row.id === 418
                                                            ? "Auto Finance Amount"
                                                            : row.id === 773 
                                                            ? "Max Finance Amount"
                                                            : lang.max_loan_amount}
                                                          <span className="right bold color-blue">
                                                            {lang.aed + " "}
                                                            {accounting.formatMoney(
                                                              row.maxLoanAmount,
                                                              "",
                                                              0
                                                            )}
                                                          </span>
                                                        </p>
                                                      </span>
                                                      <span>
                                                        <p>
                                                          {row.id === 707
                                                            ? "Flat Rate"
                                                            : lang.fixed_rate}
                                                          <span className="right bold color-blue">
                                                            {row.fixedRate.toFixed(
                                                              2
                                                            )}
                                                            {"%"}
                                                          </span>
                                                        </p>
                                                      </span>
                                                    </span>
                                                    <span>
                                                      <span>
                                                        <p>
                                                          {lang.reducing_rate}
                                                          <span className="right bold color-blue">
                                                            {row.reducingRate.toFixed(
                                                              2
                                                            )}
                                                            {"%"}
                                                          </span>
                                                        </p>
                                                      </span>
                                                      <span>
                                                        <p>
                                                          {lang.down_payment}
                                                          <span className="right bold color-blue">
                                                            {" "}
                                                            {row.downPayment.toFixed(
                                                              2
                                                            )}
                                                            {"%"}
                                                          </span>
                                                        </p>
                                                      </span>
                                                    </span>
                                                  </Segment>
                                                  <div className="quick-view-side show-for-small margin-top-20">
                                                    <Segment>
                                                      <span>
                                                        {lang.non_aed_trx_fee}
                                                      </span>
                                                      <span className="right bold color-blue">
                                                        {row.nonAedTrxFee > 0
                                                          ? row.nonAedTrxFee.toFixed(
                                                              2
                                                            ) + "%"
                                                          : "-"}
                                                      </span>
                                                    </Segment>
                                                    <Segment>
                                                      <span>
                                                        {lang.cash_advance_fee}
                                                      </span>
                                                      {!_.isEmpty(
                                                        row.cashAdvance
                                                      ) &&
                                                      row.cashAdvance
                                                        .percentage > 0 ? (
                                                        <span className="right bold color-blue">
                                                          {_.toNumber(
                                                            row.cashAdvance
                                                              .percentage
                                                          ).toFixed(2)}{" "}
                                                          % /{" "}
                                                          {isNaN(
                                                            row.cashAdvance
                                                              .amount
                                                          )
                                                            ? row.cashAdvance
                                                                .amount
                                                            : accounting.formatMoney(
                                                                row.cashAdvance
                                                                  .amount,
                                                                `${lang.aed} `,
                                                                0
                                                              )}
                                                        </span>
                                                      ) : (
                                                        <span className="right bold color-blue">
                                                          - / -
                                                        </span>
                                                      )}
                                                    </Segment>
                                                  </div>
                                                  {row.joiningOffers ? (
                                                    <Segment>
                                                      <h3 className="title">
                                                        <span>
                                                          {lang.joining_offers}
                                                        </span>
                                                      </h3>
                                                      <div
                                                        className="card-descp"
                                                        dangerouslySetInnerHTML={{
                                                          __html: _.upperFirst(
                                                            row.joiningOffers
                                                          ),
                                                        }}
                                                      ></div>
                                                    </Segment>
                                                  ) : null}

                                                  <Segment>
                                                    <Segment.Group
                                                      horizontal
                                                      className="ui basic segment  quick-view--options fromEditor"
                                                    >
                                                      {row.keyFeatures ? (
                                                        <div>
                                                          <h3 className="title">
                                                            <span>
                                                              {
                                                                lang.key_features
                                                              }
                                                            </span>
                                                          </h3>
                                                          <div
                                                            className="card-descp"
                                                            dangerouslySetInnerHTML={{
                                                              __html:
                                                                _.upperFirst(
                                                                  row.keyFeatures
                                                                ),
                                                            }}
                                                          ></div>
                                                        </div>
                                                      ) : null}
                                                      {row.rewardFeatures ? (
                                                        <div>
                                                          <h3 className="title">
                                                            <span>
                                                              {
                                                                lang.reward_features
                                                              }
                                                            </span>
                                                          </h3>
                                                          <div
                                                            className="card-descp"
                                                            dangerouslySetInnerHTML={{
                                                              __html:
                                                                _.upperFirst(
                                                                  row.rewardFeatures
                                                                ),
                                                            }}
                                                          ></div>
                                                        </div>
                                                      ) : null}
                                                      {_.isEmpty(
                                                        row.thingsToAware.filter(
                                                          Boolean
                                                        )
                                                      ) ? (
                                                        ""
                                                      ) : (
                                                        <Segment>
                                                          <h3 className="title">
                                                            <span>
                                                              {
                                                                lang.things_to_aware
                                                              }
                                                            </span>
                                                          </h3>
                                                          <ul>
                                                            {row.thingsToAware.map(
                                                              (item, idx) => (
                                                                <li key={idx}>
                                                                  {_.upperFirst(
                                                                    item
                                                                  )}
                                                                </li>
                                                              )
                                                            )}
                                                          </ul>
                                                        </Segment>
                                                      )}
                                                    </Segment.Group>
                                                  </Segment>
                                                </Segment.Group>

                                                <div
                                                  className="quick-view-content-btn hide-for-xs"
                                                  title={
                                                    row.contract
                                                      ? ""
                                                      : lang.non_contract_alert_less
                                                  }
                                                >
                                                  <Button
                                                    className="btn btn-white  show-for-desktop"
                                                    tabIndex={row.id}
                                                    onClick={
                                                      this
                                                        .toggleVisibilityForDetails
                                                    }
                                                  >
                                                    {lang.more_info}
                                                  </Button>
                                                  <Link
                                                    to={`/car-loans/details/${row.cardname}/${row.id}`}
                                                  >
                                                    <Button className="btn btn-white  show-for-xs hide-for-xs">
                                                      {lang.more_info}
                                                    </Button>
                                                  </Link>
                                                  {/* <Button basic tabIndex={row.id} onClick={this.toggleVisibilityForRivews} className='reset-styles show-for-desktop'>
                                                    <span className='cta-link color-blue bold margin-left-full'>{lang.view_reviews_and_ratings}</span>
                                                  </Button> */}

                                                  <Link
                                                    className="reset-styles show-for-small rate-small"
                                                    to={{
                                                      pathname: `/credit-cards/details/${row.cardname}/${row.id}`,
                                                      query: {
                                                        scrollDown: true,
                                                      },
                                                    }}
                                                  >
                                                    <span className="cta-link color-blue bold margin-left-full">
                                                      {
                                                        lang.view_reviews_and_ratings
                                                      }
                                                    </span>
                                                  </Link>
                                                  <Button
                                                    className="quick-view-apply-btn apply-mob btn btn-blue right margin-top-10 show-for-small"
                                                    cardid={row.id}
                                                    onClick={this.applyDirect}
                                                  >
                                                    {lang.apply}
                                                  </Button>

                                                  {/* {row.contract?
                                          <Button className='quick-view-apply-btn btn btn-blue right margin-top-10 show-for-small' cardid={row.id} onClick={this.applyDirect}>{lang.apply}</Button>:
                                          <span className='applyBtn right' onClick={this.handleContractAlert}><Button className='quick-view-apply-btn btn btn-blue right margin-top-10 show-for-small disabled fullWidth' cardid={row.id}>{lang.apply}</Button></span>
                                        } */}
                                                </div>
                                              </Segment>

                                              <Segment.Group className="ui basic segment hide-for-xs">
                                                <Segment>
                                                  <div className="quick-view-side apply-now-detail quick__apply-now show-for-desktop">
                                                    <h2>Apply Now</h2>

                                                    <ApplyForm
                                                      key={index}
                                                      data={{
                                                        closeDirectApplyPopup:
                                                          this
                                                            .closeDirectApplyPopup,
                                                        popupOpen:
                                                          this.directApply,
                                                        applyCardObject: row,
                                                      }}
                                                      submitButton={false}
                                                      submitted={this.submitted}
                                                      suggest={this.suggest}
                                                    />
                                                  </div>
                                                </Segment>
                                              </Segment.Group>
                                            </Segment.Group>

                                            <div className="quick-view-content-btn show-less-900">
                                              <Button
                                                className="btn btn-white show-for-desktop"
                                                tabIndex={row.id}
                                                onClick={
                                                  this
                                                    .toggleVisibilityForDetails
                                                }
                                              >
                                                {lang.more_details}
                                              </Button>
                                              <Link
                                                to={`/credit-cards/details/${row.cardname}/${row.id}`}
                                              >
                                                <Button className="btn btn-white show-for-small">
                                                  {lang.more_details}
                                                </Button>
                                              </Link>
                                              <Button
                                                basic
                                                tabIndex={row.id}
                                                onClick={
                                                  this.toggleVisibilityForRivews
                                                }
                                                className="reset-styles show-for-desktop"
                                              >
                                                <span className="cta-link color-blue bold margin-left-full">
                                                  {
                                                    lang.view_reviews_and_ratings
                                                  }
                                                </span>
                                              </Button>

                                              <Link
                                                className="reset-styles show-for-small rate-small"
                                                to={{
                                                  pathname: `/credit-cards/details/${row.cardname}/${row.id}`,
                                                  query: { scrollDown: true },
                                                }}
                                              >
                                                <span className="cta-link color-blue bold margin-left-full">
                                                  {
                                                    lang.view_reviews_and_ratings
                                                  }
                                                </span>
                                              </Link>
                                              {/* <Button className='quick-view-apply-btn apply-mob btn btn-blue right margin-top-10 show-for-desktop' cardid={row.id} onClick={this.applyDirect}>{lang.apply}</Button> */}
                                              <Button
                                                className="quick-view-apply-btn btn btn-blue right margin-top-10 hide-for-xs"
                                                cardid={row.id}
                                                onClick={this.applyDirect}
                                              >
                                                {lang.apply}
                                              </Button>
                                              {/* {row.contract?
                                        <Button className='quick-view-apply-btn btn btn-blue right margin-top-10 show-for-small' cardid={row.id} onClick={this.applyDirect}>{lang.apply}</Button>:
                                        <span className='applyBtn right' onClick={this.handleContractAlert}><Button className='quick-view-apply-btn btn btn-blue right margin-top-10 show-for-small disabled fullWidth' cardid={row.id}>{lang.apply}</Button></span>
                                      } */}
                                            </div>
                                          </Accordion.Content>
                                        </Accordion>
                                      </Segment>
                                    </div>
                                  </div>
                                </div>
                              </div>, // note the comma
                            ];
                          })
                        ) : (
                          <div>
                            <div className="padding-top-20 padding-btm-20">
                              <div className="margin-top-full text-center">
                                {this.props.gotAutoLoanDataFromApi ? (
                                  <span>{lang.no_records_found}</span>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        {_.difference(
                          this.props.cardDetails,
                          cardDetailsToDisplay
                        ).length > 0 ? (
                          <div className="text-center width-100 left btn-mar-10">
                            <div className="padding-top-20 padding-btm-20">
                              <Button
                                className="btn btn-white"
                                onClick={this.setNumberOfCardToShow}
                              >
                                {lang.load_more}
                              </Button>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                        {_.isEmpty(this.state.autoLoan) ? (
                          ""
                        ) : (
                          <BrowserView>
                            <div className="listFaq">
                              <div className="listFaqTitle">
                                <h5 className="left">
                                  Frequently Asked Questions
                                </h5>
                                <Button
                                  className="ui button right btn-blue-hover"
                                  onClick={this.handleExpandCollapse}
                                >
                                  {!this.state.expandAll
                                    ? lang.expand_all
                                    : lang.collapse_all}
                                </Button>
                              </div>
                              {this.state.autoLoan.map((row, idx) => (
                                <Accordion key={idx}>
                                  <Accordion.Title
                                    active={activeIndex === row.index}
                                    index={row.index}
                                    onClick={this.handleClick}
                                  >
                                    {activeIndex === row.index ||
                                    this.state.expandAll ? (
                                      <img
                                        className="blue-shadow"
                                        src="https://soulwallet.imgix.net/static-compressed/assets/home/collapse-faq-new.png?auto=compess&fm=webp%7Cauto=compress"
                                        alt=""
                                      />
                                    ) : (
                                      <img
                                        className="grey-shadow"
                                        src="https://soulwallet.imgix.net/static-compressed/assets/home/pause-faq.png?auto=compress&fm=webp%7Cauto=compress"
                                        alt=""
                                      />
                                    )}
                                    <span>{row.title}</span>
                                    {/* <span className='right'>
                       <Icon name='angle down' />
                       <Icon name='angle up' />
                     </span>            */}
                                  </Accordion.Title>
                                  <Accordion.Content
                                    active={activeIndex === row.index}
                                  >
                                    {row.p2 === "" ? (
                                      <p>{row.p1}</p>
                                    ) : (
                                      <React.Fragment>
                                        <p>{row.p1}</p>
                                        <p>{row.p2}</p>
                                      </React.Fragment>
                                    )}
                                  </Accordion.Content>
                                </Accordion>
                              ))}
                            </div>
                          </BrowserView>
                        )}
                      </div>
                    </div>
                  </div>
                  <DirectApply
                    data={{
                      closeDirectApplyPopup: this.closeDirectApplyPopup,
                      popupOpen: this.state.directApply,
                      applyCardObject: this.state.applyCardObject,
                    }}
                    suggest={this.suggest}
                  />
                </div>
              </div>
              <Sidebar
                as={Container}
                animation="overlay"
                width="very wide"
                direction="right"
                visible={this.state.toggleVisible}
                icon="labeled"
                className="sidebar-more-details"
              >
                <Menu.Item>
                  <SidePdp
                    cardDetails={this.state.showMoreCardObj}
                    closeSidePdp={this.closeSidePdp}
                    changePdpByCardId={this.changePdpByCardId}
                    changeSidePdp={this.changeSidePdp}
                    enableButton={this.state.sidePdpEnableButton}
                    simulatorOpen={this.simulatorClick}
                    applyDirect={this.applyDirectFromsidePDP}
                  />
                </Menu.Item>
              </Sidebar>
            </Segment.Group>
          </div>
        </div>
        {this.state.toggleVisible ? (
          <div>
            <div className="backdrop-sidebar"></div>
            <style>{" body, html {overflow: hidden; }"}</style>{" "}
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}

// AutoLoanContainer.js
const mapStateToProps = (state, ownProps) => ({
  cardDetails: state.autoLoanDetails,
  allCardDetails: state.allAutoLoanDetails,
  appliedEmiForAutoLoans: state.appliedAutoLoanEmi,
  filterAttribute: state.autoLoanFilterAttribute,
  gotApiData: state.autoLoanLoading.gotApiData,
  compareCards: state.compareAutoLoanData.compareCards,
  compareChecked: state.compareAutoLoanData.compareChecked,
  gotAutoLoanDataFromApi: state.gotAutoLoanDataFromApi,
  allowInput: state.simulateEmail.allowInput,
  simulateEmail: state.simulateEmail.email,
  autoLoanEmiInputValue: state.autoLoanEmiInputValue,
  nextAutoLoanCallApi: state.nextAutoLoanCallApi,
  activeLanguage: state.activeLanguage,
  applyInputForm: state.applyInputForm,
});

const mapDispatchToProps = {
  storeAutoLoanDetails,
  getAutoLoanData,
  storeAutoLoanFilterValue,
  storeCategoryAutoLoanCount,
  compareAutoLoanData,
  storeSimulateEmail,
  storeAllAutoLoanDetails,
  appliedAutoLoanEmi,
  removedAutoLoanEmi,
  storeAutoLoanEmiInputValue,
  setGotAutoLoanDataFromApi,
  storeApplyFormInput,
  makeapplySuccess,
};

const AutoLoanContainer = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AutoLoans)
);

export default AutoLoanContainer;



// WEBPACK FOOTER //
// ./src/components/autoLoans/AutoLoans.js